(function () {
  if (window.WSTNUX) {
    return;
  }

  var MOTION = {
    COUNTUP_DURATION: 2000,
    REVEAL_DURATION: 1000
  };
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealObserver = null;
  var countObserver = null;

  function prefersReducedMotion() {
    return reduceMotionQuery.matches;
  }

  function syncMotionConstants() {
    document.documentElement.style.setProperty('--wstn-motion-countup-duration', MOTION.COUNTUP_DURATION + 'ms');
    document.documentElement.style.setProperty('--wstn-motion-reveal-duration', MOTION.REVEAL_DURATION + 'ms');
  }

  function parseNumericText(raw) {
    if (!raw) {
      return null;
    }

    var match = raw.trim().match(/^([^0-9-]*)(-?\d[\d,]*\.?\d*)(.*)$/);

    if (!match) {
      return null;
    }

    var prefix = match[1] || '';
    var numericText = match[2].replace(/,/g, '');
    var suffix = match[3] || '';
    var value = parseFloat(numericText);

    if (Number.isNaN(value)) {
      return null;
    }

    var decimalMatch = numericText.match(/\.(\d+)$/);

    return {
      prefix: prefix,
      value: value,
      suffix: suffix,
      decimals: decimalMatch ? decimalMatch[1].length : 0,
      original: raw.trim()
    };
  }

  function formatNumericText(parsed, value) {
    return parsed.prefix + value.toLocaleString(undefined, {
      minimumFractionDigits: parsed.decimals,
      maximumFractionDigits: parsed.decimals
    }) + parsed.suffix;
  }

  function markRevealVisible(element) {
    element.classList.add('is-visible');
  }

  function initReveal(root) {
    var elements = root.querySelectorAll('[data-wstn-reveal]');

    elements.forEach(function (element) {
      if (element.dataset.wstnRevealReady === 'true') {
        return;
      }

      element.dataset.wstnRevealReady = 'true';

      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        markRevealVisible(element);
        return;
      }

      if (!revealObserver) {
        revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            markRevealVisible(entry.target);
            revealObserver.unobserve(entry.target);
          });
        }, {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        });
      }

      revealObserver.observe(element);
    });
  }

  function runCountup(element) {
    if (element.dataset.wstnCounted === 'true') {
      return;
    }

    var parsed = parseNumericText(element.dataset.wstnCountOriginal || element.textContent);

    if (!parsed) {
      element.dataset.wstnCounted = 'true';
      return;
    }

    if (prefersReducedMotion()) {
      element.textContent = parsed.original;
      element.dataset.wstnCounted = 'true';
      return;
    }

    var duration = MOTION.COUNTUP_DURATION;
    var startTime = null;

    function frame(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var currentValue = parsed.value * eased;

      element.textContent = formatNumericText(parsed, currentValue);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        element.textContent = parsed.original;
        element.dataset.wstnCounted = 'true';
      }
    }

    requestAnimationFrame(frame);
  }

  function initCountups(root) {
    var elements = root.querySelectorAll('[data-wstn-countup]');

    elements.forEach(function (element) {
      if (element.dataset.wstnCountReady === 'true') {
        return;
      }

      var parsed = parseNumericText(element.textContent);

      if (!parsed) {
        element.dataset.wstnCountReady = 'true';
        element.dataset.wstnCounted = 'true';
        return;
      }

      element.dataset.wstnCountReady = 'true';
      element.dataset.wstnCountOriginal = parsed.original;

      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        element.dataset.wstnCounted = 'true';
        element.textContent = parsed.original;
        return;
      }

      if (!countObserver) {
        countObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            runCountup(entry.target);
            countObserver.unobserve(entry.target);
          });
        }, {
          threshold: 0.35,
          rootMargin: '0px 0px -5% 0px'
        });
      }

      countObserver.observe(element);
    });
  }

  function getSlideLeft(track, slide) {
    return slide.offsetLeft - track.offsetLeft;
  }

  function initSlider(root) {
    var sliders = root.querySelectorAll('[data-wstn-slider]');

    sliders.forEach(function (slider) {
      if (slider.dataset.wstnSliderReady === 'true') {
        return;
      }

      var track = slider.querySelector('[data-wstn-slider-track]');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-wstn-slide]')) : [];

      if (!track || slides.length === 0) {
        slider.dataset.wstnHasOverflow = 'false';
        slider.dataset.wstnSliderReady = 'true';
        return;
      }

      var previousButton = slider.querySelector('[data-wstn-slider-prev]');
      var nextButton = slider.querySelector('[data-wstn-slider-next]');
      var dotsContainer = slider.querySelector('[data-wstn-slider-dots]');
      var activeIndex = 0;

      function setOverflowState() {
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;
        slider.dataset.wstnHasOverflow = hasOverflow ? 'true' : 'false';
        return hasOverflow;
      }

      function updateActiveIndex() {
        var closestIndex = 0;
        var closestDistance = Infinity;

        slides.forEach(function (slide, index) {
          var distance = Math.abs(track.scrollLeft - getSlideLeft(track, slide));

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        activeIndex = closestIndex;

        if (previousButton) {
          previousButton.disabled = activeIndex === 0;
        }

        if (nextButton) {
          nextButton.disabled = activeIndex >= slides.length - 1;
        }

        if (dotsContainer) {
          Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-wstn-slider-dot]')).forEach(function (dot, index) {
            dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
          });
        }
      }

      function scrollToIndex(index) {
        var boundedIndex = Math.max(0, Math.min(index, slides.length - 1));
        var left = getSlideLeft(track, slides[boundedIndex]);

        track.scrollTo({
          left: left,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      if (dotsContainer && dotsContainer.childElementCount === 0) {
        slides.forEach(function (_, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'wstn-slider__dot';
          button.dataset.wstnSliderDot = 'true';
          button.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          button.addEventListener('click', function () {
            scrollToIndex(index);
          });
          dotsContainer.appendChild(button);
        });
      }

      if (previousButton) {
        previousButton.addEventListener('click', function () {
          scrollToIndex(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scrollToIndex(activeIndex + 1);
        });
      }

      var scrollFrame = null;

      track.addEventListener('scroll', function () {
        if (scrollFrame) {
          cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = requestAnimationFrame(updateActiveIndex);
      }, {
        passive: true
      });

      window.addEventListener('resize', function () {
        setOverflowState();
        updateActiveIndex();
      }, {
        passive: true
      });

      document.addEventListener('shopify:block:select', function (event) {
        var selectedSlide = event.target.closest('[data-wstn-slide]');

        if (!selectedSlide || !slider.contains(selectedSlide)) {
          return;
        }

        var index = slides.indexOf(selectedSlide);

        if (index > -1) {
          scrollToIndex(index);
        }
      });

      setOverflowState();
      updateActiveIndex();
      slider.dataset.wstnSliderReady = 'true';
    });
  }

  function initMarquees(root) {
    var marquees = root.querySelectorAll('[data-wstn-marquee]');

    marquees.forEach(function (marquee) {
      if (marquee.dataset.wstnMarqueeBase == null) {
        var initialGroup = marquee.querySelector('[data-wstn-marquee-group]');
        marquee.dataset.wstnMarqueeBase = initialGroup ? initialGroup.innerHTML : '';
      }

      if (marquee.dataset.wstnMarqueeReady === 'true') {
        return;
      }

      var viewport = marquee.querySelector('[data-wstn-marquee-viewport]');
      var track = marquee.querySelector('[data-wstn-marquee-track]');
      var groups = marquee.querySelectorAll('[data-wstn-marquee-group]');

      if (!viewport || !track || groups.length < 2 || marquee.dataset.wstnMarqueeBase === '') {
        marquee.dataset.wstnMarqueeReady = 'true';
        return;
      }

      var resizeFrame = null;

      function syncGroups() {
        var baseMarkup = marquee.dataset.wstnMarqueeBase;

        groups[0].innerHTML = baseMarkup;
        groups[1].innerHTML = baseMarkup;

        if (prefersReducedMotion()) {
          track.style.removeProperty('--wstn-marquee-shift');
          return;
        }

        var iterations = 0;

        while (groups[0].scrollWidth < viewport.clientWidth + 48 && iterations < 8) {
          groups[0].insertAdjacentHTML('beforeend', baseMarkup);
          iterations += 1;
        }

        groups[1].innerHTML = groups[0].innerHTML;
        track.style.setProperty('--wstn-marquee-shift', groups[0].scrollWidth + 'px');
      }

      syncGroups();

      window.addEventListener('resize', function () {
        if (resizeFrame) {
          cancelAnimationFrame(resizeFrame);
        }

        resizeFrame = requestAnimationFrame(syncGroups);
      }, {
        passive: true
      });

      marquee.dataset.wstnMarqueeReady = 'true';
    });
  }

  function parseReviewPayload(payload) {
    if (!payload) {
      return null;
    }

    var ratingValueMatch = payload.match(/ratingValue"\s*:\s*"?([0-9.]+)"?/i);
    var reviewCountMatch = payload.match(/(?:reviewCount|ratingCount)"\s*:\s*"?([0-9]+)"?/i);
    var ratingValue = ratingValueMatch ? parseFloat(ratingValueMatch[1]) : null;
    var reviewCount = reviewCountMatch ? parseInt(reviewCountMatch[1], 10) : null;

    if (!ratingValue || !reviewCount) {
      return null;
    }

    return {
      ratingValue: ratingValue,
      reviewCount: reviewCount
    };
  }

  function initReviewSummaries(root) {
    var summaries = root.querySelectorAll('[data-wstn-review-summary]');

    summaries.forEach(function (summary) {
      if (summary.dataset.wstnReviewReady === 'true') {
        return;
      }

      summary.dataset.wstnReviewReady = 'true';

      if (summary.querySelector('.rating')) {
        return;
      }

      var parsed = parseReviewPayload(summary.getAttribute('data-wstn-review-payload'));

      if (!parsed) {
        summary.classList.add('is-hidden');
        return;
      }

      var meter = document.createElement('span');
      var base = document.createElement('span');
      var fill = document.createElement('span');
      var count = document.createElement('span');
      var percentage = Math.max(0, Math.min(parsed.ratingValue / 5, 1)) * 100;

      meter.className = 'wstn-inline-rating__meter';
      meter.setAttribute('aria-hidden', 'true');
      base.className = 'wstn-inline-rating__meter-base';
      fill.className = 'wstn-inline-rating__meter-fill';
      fill.style.width = percentage + '%';
      base.textContent = '★★★★★';
      fill.textContent = '★★★★★';
      meter.appendChild(base);
      meter.appendChild(fill);

      count.className = 'wstn-inline-rating__count';
      count.textContent = '(' + parsed.reviewCount + ')';

      summary.setAttribute('aria-label', parsed.ratingValue.toFixed(1) + ' out of 5 stars from ' + parsed.reviewCount + ' reviews');
      summary.appendChild(meter);
      summary.appendChild(count);
      summary.classList.remove('is-hidden');
    });
  }

  function initProductFormBindings(root) {
    var forms = root.querySelectorAll('form[is="product-form"]');

    forms.forEach(function (form) {
      if (form.dataset.wstnProductBindingsReady === 'true') {
        return;
      }

      form.dataset.wstnProductBindingsReady = 'true';
      form.addEventListener('product:rerender', function () {
        requestAnimationFrame(function () {
          init(document);
        });
      });
    });
  }

  function init(root) {
    var scopedRoot = root || document;
    syncMotionConstants();
    initProductFormBindings(scopedRoot);
    initMarquees(scopedRoot);
    initReveal(scopedRoot);
    initCountups(scopedRoot);
    initSlider(scopedRoot);
    initReviewSummaries(scopedRoot);
  }

  window.WSTNUX = {
    MOTION: MOTION,
    init: init,
    prefersReducedMotion: prefersReducedMotion
  };

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
